module.exports = require("eth-lib/lib/bytes");